import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import * as actions from '../store/options.actions'
import { IRulesResponse } from '../../../common/common.types'
import { createIndexedRules } from '../../../utilities/runRulesValidation.util'
import { GlobalOptionsService } from '../services/globalOptions.service'
import { GlobalDataConstants } from '../../globalData/store/globalData.constants'
import { setErrorMessage, showToast } from '../../../components/apiErrorHandler/store/apiErrorHandler.actions'
import { OptionsService } from '../services/options.service'
import { getServiceIdSelector } from '../../user/selectors'
import Logger from '../../../services/logger.service'
import { RulesService } from '../../validation/services/rules.service'
import { IClientDataDoc } from '../../../services/clientData.service'
import { getVersion, isOffline } from '../../../utilities'
import { GlobalDataMetadataService } from '../../../services/globalDataMetadata.service'

export function* setRulesOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  const globalOptionsService = new GlobalOptionsService()
  const globalDataMetadataService = new GlobalDataMetadataService()
  const rulesService = new RulesService(serviceId)

  const STANDARD_RULES = globalOptionsService.STANDARD_RULES
  const XSD_RULES = globalOptionsService.XSD_RULES

  try {
    const stdRulesResponse: IRulesResponse = yield call([globalOptionsService, globalOptionsService.getStandardRules])
    const xsdRulesResponse: IRulesResponse = yield call([globalOptionsService, globalOptionsService.getXsdRules])
    const nationalRulesResponse: IClientDataDoc = yield call([rulesService, rulesService.getNationalRules])
    const serviceRulesResponse: IClientDataDoc = yield call([optionsService, optionsService.getServiceRules])

    if (
      isOffline() &&
      (!stdRulesResponse ||
        stdRulesResponse.version !== getVersion() ||
        !xsdRulesResponse ||
        xsdRulesResponse.version !== getVersion())
    ) {
      yield call([globalOptionsService, globalOptionsService.removeDoc], STANDARD_RULES)
      yield call([globalOptionsService, globalOptionsService.removeDoc], XSD_RULES)
      yield call([globalDataMetadataService, globalDataMetadataService.removeDoc], STANDARD_RULES)
      yield call([globalDataMetadataService, globalDataMetadataService.removeDoc], XSD_RULES)
      Logger.info(`Rules: Rules docs are out of date. Service: ${serviceId}`)

      yield put(
        setErrorMessage(
          'Please login to the emsCharts NOW in an online state so that we can complete the download of your configurations.'
        )
      )
      yield put(showToast(true))
    } else {
      yield put(
        actions.setRulesOptions(
          stdRulesResponse?.rules || [],
          createIndexedRules(stdRulesResponse?.rules || []),
          xsdRulesResponse?.rules || [],
          createIndexedRules(xsdRulesResponse?.rules || []),
          nationalRulesResponse?.entity || [],
          createIndexedRules(nationalRulesResponse?.entity || []),
          serviceRulesResponse?.entity || [],
          createIndexedRules(serviceRulesResponse?.entity || [])
        )
      )
    }
  } catch (e) {
    yield put(throwPcrException(`setRulesOptions() error: ${e}`))
  }
}
export function* setRulesOptionsSaga() {
  yield takeLatest([GlobalDataConstants.ON_GLOBAL_DATA_IMPORT_SUCCESS], setRulesOptions)
}
